import React from "react";
import Slider from "react-slick";
import VideoPlayer from "../../common/VideoPlayer";
import { handlePlayerReady, pauseVideo, share } from "../../utils/Helper";
import { toHaveFormValues } from "@testing-library/jest-dom/dist/matchers";
import $ from "jquery";

const ReelSlider = ({
  reel,
  showpopup,
  handleShareData,
  handleBack,
  activeIndex,
  activeIndexForSlide,
  Type,
  sharetext
}) => {
  const settings = {
    initialSlide: activeIndexForSlide,
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    autoplay: false,
    verticalSwiping: true,
    beforeChange: (current, next) => {
      const currentVideoId = reel[current]?.id;
      if (currentVideoId) {
        pauseVideo(currentVideoId, Type);
      }
    },

    afterChange: (current) => {
      const currentVideoId = reel[current]?.id;
      let videoid = "myVideo_" + Type + "_" + currentVideoId + "_html5_api";

      let el = document.getElementById(videoid);

      console.log(currentVideoId);
      console.log(el);

      if (el) {
        el.play();
      } else {
        console.error(`Video element with ID "${videoid}" not found.`);
      }
    },

    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {reel.map((shorts, index) => {
        return (
          <div key={shorts?.id}>
            <div className="short_video_play">
              <button className="close_poppup_btn" onClick={() => handleBack()}>
                <img src="/assets/images/leftarrow2.svg" className="" alt="" />
              </button>
              <button
                className="reelshare_btn"
                onClick={() => {
                  share(
                    shorts.id,
                    sharetext,
                    "youtube",
                    `https://www.narendramodi.in/parikshapecharcha2025/${shorts.episode_id}/graphics/${shorts.id}`
                  );
                  handleShareData(
                    `https://www.narendramodi.in/parikshapecharcha2025/${shorts.episode_id}/graphics/${shorts.id}`,
                    sharetext,
                    sharetext,
                    "youtube"
                  );
                }}
              >
                <img src="/assets/images/sharereel.svg" alt="" />
              </button>
              <VideoPlayer
                onReady={handlePlayerReady}
                id={shorts?.id}
                keyi={shorts?.id}
                video_url={shorts?.video_url}
                thumb={shorts?.thumb_url}
                activeIndex={activeIndex}
                index={index}
                type={Type}
              />
              {/* <div className="reelslider_overlay2" 
               ></div> */}
              <div className="reel_content">
                <p>{shorts?.title}</p>
                {/* <h4>Sanjeev Katwal</h4> */}
                <h5>{shorts?.description}</h5>
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  );
};

export default ReelSlider;
